module.exports = __webpack_public_path__ + "img/Girlshot_1.jpg";